<script>
import { mapGetters } from 'vuex';
import AIChatWidget from './components/ai-chat-widget/ai-chat-widget.vue';
import FloatingUploadPanel from './components/ui/floating-upload-panel.vue';

export default {
  name: "app",
  components: {
    AIChatWidget,
    FloatingUploadPanel
  },
  computed: {
    ...mapGetters('account/auth', ['user']),
    showAIChatWidget() {
      // Check if user is logged in
      const isLoggedIn = !!this.user;
      
      // Check if current route path contains '/archive'
      const currentPath = this.$route?.path || '';
      const isArchivePath = currentPath.includes('/archive-master');
      const appAIMode = process.env.VUE_APP_AI_MODE === 'true' ? true : false;
      
      return isLoggedIn && isArchivePath && appAIMode;
    }
  }
};
</script>

<template>
  <div id="app">
    <RouterView />
    <AIChatWidget v-if="showAIChatWidget" />
    <FloatingUploadPanel v-if="showAIChatWidget && $isAdminAndClient()" />
  </div>
</template>
